<template lang="pug">
.inteligencia-territorial-imovel
    BaseHeaderInteligenciaTerritorial(
        :titulo='car',
        :breadcrumb='breadcrumb',
        :voltarPara='true'
    )
    .view-container-base-header
        .inteligencia-territorial-container__container
            h3 {{ $t('mensagens.inteligenciaTerritorial.dadosGeraisImovel') }}
            CardInteligenciaTerritorialDadosGeraisImovel(
                v-if='informacoesCar',
                :informacoesCar='informacoesCar'
            )
            h3 {{ $t('mensagens.inteligenciaTerritorial.potencialAgropecuario') }}
                el-tooltip.ml-2(
                    effect='dark',
                    placement='right-start',
                    :content="$t('mensagens.inteligenciaTerritorial.imovel.dadosReferentesSafra')"
                )
                    i.el-icon-warning-outline
            div.grid-layout-potencial-agro
                div
                    CardInteligenciaTerritorialPotencialAgropecuarioPastagemImovel(
                        :areaTotal='areaTotal'
                    )
                div.row-span
                    CardInteligenciaTerritorialPotencialAgropecuarioAreaPlantadaImovel(
                        :areaTotal='areaTotal'
                    )
                div
                    CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel(
                        :areaTotal='areaTotal'
                    )
                div
                    CardInteligenciaTerritorialPotencialAgropecuarioOutrosImovel(
                        :areaTotal='areaTotal'
                    )

            h3 {{ $t('mensagens.inteligenciaTerritorial.dadosSocioambientais') }}
            .dados-gerais-territorio-monitoramento__lista
                .dados-gerais-territorio-monitoramento__lista-item(
                    v-for='(situacao, index) in carSituacaoCamadaCategoria',
                    :key='index'
                )
                    BlocoSituacaoTerritorio(
                        :titulo='situacao.camadaCategoria.nome',
                        :subTitulo="$t('mensagens.inteligenciaTerritorial.naoConformidades')",
                        :valor='situacao.qtdeNaoConformidade',
                        @click.native='exibirModalVisualizarEmbargosInteligenciaTerritorial(situacao)'
                    )
            h3 {{ $t('mensagens.inteligenciaTerritorial.producaoAgricola') }}
            .inteligencia-territorial-container__container
                .linha__divisoria
                ProducaoAgricola(
                    :dadosAreaPlantadaGrafico='dadosAreaPlantadaGrafico || []',
                    :categoriasAreaPlantadaGrafico='categoriasAreaPlantadaGrafico || []',
                    :dadosProdutividadeGrafico='dadosProdutividadeGrafico || []',
                    :categoriasProdutividadeGrafico='categoriasProdutividadeGrafico || []',
                    :territorioGeometria='territorioGeometria',
                    :glebas='glebas',
                    @atualizarCodigosCulturas='atualizarCodigosCulturas'
                )
            div(style='margin-top: -90px;')
                h3 {{ $t('mensagens.inteligenciaTerritorial.dadosClimaticos') }}
                .inteligencia-territorial-container__container
                    .linha__divisoria
                    GraficoChuvaAcumuladaAno(
                        :dadosClimaticos='dadosClimaticos'
                    )

    ModalVisualizarEmbargosInteligenciaTerritorial(
        :situacao='situacao',
        :territorio='territorioGeometria',
        :show='showModalVisualizarEmbargosInteligenciaTerritorial',
        @close='showModalVisualizarEmbargosInteligenciaTerritorial = false'
    )
</template>
<script>
import BaseHeaderInteligenciaTerritorial from '@/components/BaseHeaderInteligenciaTerritorial.vue';
import CardInteligenciaTerritorialDadosGeraisImovel from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/CardInteligenciaTerritorialDadosGeraisImovel.vue';
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import CardInteligenciaTerritorialPotencialAgropecuarioPastagemImovel from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/CardInteligenciaTerritorialPotencialAgropecuarioPastagemImovel.vue';
import CardInteligenciaTerritorialPotencialAgropecuarioOutrosImovel from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/CardInteligenciaTerritorialPotencialAgropecuarioOutrosImovel.vue';
import CardInteligenciaTerritorialPotencialAgropecuarioAreaPlantadaImovel from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/CardInteligenciaTerritorialPotencialAgropecuarioAreaPlantadaImovel.vue';
import CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel.vue';
import ModalVisualizarEmbargosInteligenciaTerritorial from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/ModalVisualizarEmbargosInteligenciaTerritorial.vue';
import BlocoSituacaoTerritorio from '@/components/monitoramento/BlocoSituacaoTerritorio';
import CamadasCategorias from '@/utils/camadasCategorias';
import InteligenciaTerritorialService from '@/services/InteligenciaTerritorialService';
import TerritorioService from '@/services/TerritorioService';
import ProducaoAgricola from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/ProducaoAgricola.vue';
import GraficoChuvaAcumuladaAno from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/GraficoChuvaAcumuladaAno.vue';

export default {
    name: 'InteligenciaTerritorialImovel',
    components: {
        CardInteligenciaTerritorialPotencialAgropecuarioPastagemImovel,
        CardInteligenciaTerritorialPotencialAgropecuarioAreaPlantadaImovel,
        CardInteligenciaTerritorialPotencialAgropecuarioOutrosImovel,
        CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel,
        BaseHeaderInteligenciaTerritorial,
        CardInteligenciaTerritorialDadosGeraisImovel,
        BlocoSituacaoTerritorio,
        ModalVisualizarEmbargosInteligenciaTerritorial,
        ProducaoAgricola,
        GraficoChuvaAcumuladaAno
    },
    data() {
        return {
            breadcrumb: [
                { nome: this.$t('mensagens.inteligenciaTerritorial.visaoGeral'), rota: '/inteligencia-territorial' }
            ],
            car: this.$route?.params?.car,
            areaTotal: {},
            informacoesCar: null,
            filtros: {
                cicloSafra: 1
            },
            carSituacaoCamadaCategoria: [],
            situacao: {},
            showModalVisualizarEmbargosInteligenciaTerritorial: false,
            territorioGeometria: {},
            glebas: [],
            codigosCulturas: 'SOJA',
            dadosAreaPlantadaGrafico: [],
            categoriasAreaPlantadaGrafico: [],
            dadosProdutividadeGrafico: [],
            categoriasProdutividadeGrafico: [],
            dadosClimaticos: []
        };
    },

    async created() {
        await this.pesquisaInteligente();
        await this.atualizarFiltro();
        await this.filtrarAreaTotal();
        await this.buscarAreasPlantadasMapBiomas();
        await this.buscarDadosClimaticos();
    },

    async mounted() {
        await this.buscarSituacaoTerritorio();
        await this.buscarGeometriaCar();
    },

    beforeDestroy() {
        if (this.$route.name !== 'InteligenciaTerritorial' && this.$route.name !== 'InteligenciaTerritorialComUf' && this.$route.name !== 'InteligenciaTerritorialComMunicipio') {
            this.$store.dispatch('limparFiltroInteligenciaTerritorial');
        }
    },

    methods: {
        async filtrarAreaTotal() {
            try {
                if (this.filtros.tipoAgrupamento === 'MUNICIPIO' || this.filtros.codigosCars.length > 0) {
                    this.filtros.possuiRestricao = null;
                    await InteligenciaTerritorialService.filtrarAreaTotalPorCARs(this.filtros).then(
                        ({data}) => {
                            if (data.length > 0) {
                                this.areaTotal = data[0];
                            } else {
                                this.areaTotal = {};
                            }
                        }
                    );
                } else {
                    await InteligenciaTerritorialService.filtrarAreaTotalPorMunicipios(this.filtros).then(
                        ({data}) => {
                            if (data.length > 0) {
                                this.areaTotal = data[0];
                            } else {
                                this.areaTotal = {};
                            }
                        }
                    );
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.inteligenciaTerritorial.erro.naoFoiPossivelIdentificarFiltro')
                });
            }
        },

        async buscarAreasPlantadasMapBiomas() {
            try {
                const ultimos5Anos = this.gerarStringUltimos5Anos() || '2022';
                await InteligenciaTerritorialService.buscarAreasPlantadasMapBiomas(
                    ultimos5Anos,
                    this.codigosCulturas,
                    this.car
                ).then(({ data }) => {
                    if (data && data?.data?.areasPlantadas.length > 0) {
                        let DadosPorAno = this.ordenarDadosPorAno(
                            data?.data?.areasPlantadas
                        );
                        this.renomearGraficoProps(DadosPorAno);
                        this.glebas = data?.data?.areasPlantadas;
                    } else {
                        this.dadosAreaPlantadaGrafico = [];
                        this.dadosProdutividadeGrafico = [];
                        this.categoriasAreaPlantadaGrafico = [];
                        this.categoriasProdutividadeGrafico = [];
                    }
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.inteligenciaTerritorial.erro.naoFoiPossivelBuscarDadosAreasPlantadas')
                });
            }
        },

        async buscarDadosClimaticos() {
            let anoAtual = new Date().getFullYear();
            let ultimoDiaAno = new Date(anoAtual, 11, 31);
            let body = {
                car: this.car,
                dataInicio: '01/01/2019',
                dataFim: this.formatDate(ultimoDiaAno),
                acumuladoMensal: true
            };
            try {
                await InteligenciaTerritorialService.buscarDadosClimaticos(
                    body
                ).then(({ data }) => {
                    if (data) {
                        this.dadosClimaticos = this.transformarDadosParaGrafico(data?.resultados);
                    } else {
                        this.dadosClimaticos = [];
                    }
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.inteligenciaTerritorial.erro.naoFoiPossivelBuscarDadosClimaticos')
                });
            }
        },

        transformarDadosParaGrafico(dados) {
            const anos = {};
            const mediaHistorica = {
                name: this.$t('mensagens.inteligenciaTerritorial.mediaHistorica'),
                type: 'line',
                data: Array(12).fill(0)
            };

            for (const dado of dados) {
                const ano = dado?.data.split('/')[2];
                const mes = parseInt(dado?.data.split('/')[1], 10) - 1;

                if (!anos[ano]) {
                    anos[ano] = {
                        name: ano,
                        type: 'column',
                        data: Array(12).fill(0)
                    };
                }

                anos[ano].data[mes] += dado?.valor;
                mediaHistorica.data[mes] += dado?.valor;
            }

            const numAnos = Object.keys(anos).length;
            mediaHistorica.data = mediaHistorica?.data.map((valor) => valor / numAnos);

            const resultado = Object.values(anos);
            resultado.push(mediaHistorica);

            return resultado;
        },

        formatDate(date) {
            return [
                this.padTo2Digits(date.getDate()),
                this.padTo2Digits(date.getMonth() + 1),
                date.getFullYear()
            ].join('/');
        },

        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },

        gerarStringUltimos5Anos() {
            let anoAtual = Number(new Date().getFullYear()) - 2;
            let anoInicial = anoAtual - 4;
            let stringAnos = '';
            for (let i = anoInicial; i <= anoAtual; i++) {
                stringAnos += i;
                if (i < anoAtual) {
                    stringAnos += ',';
                }
            }
            return stringAnos;
        },

        ordenarDadosPorAno(array) {
            array.sort((a, b) => a.ano - b.ano);
            return array;
        },

        async renomearGraficoProps(arr) {
            this.dadosAreaPlantadaGrafico = [];
            this.dadosProdutividadeGrafico = [];
            let categorias = [];
            let dadosAreaPlantadaGrafico = [];
            let dadosProdutividadeGrafico = [];

            arr.map(item => {
                categorias.push(item?.ano);
                dadosAreaPlantadaGrafico = [
                    {
                        name: this.$t('mensagens.inteligenciaTerritorial.periodo'),
                        data: arr.map(item => item?.areaHa)
                    }
                ];
                dadosProdutividadeGrafico = [
                    {
                        name: this.$t('mensagens.inteligenciaTerritorial.periodo'),
                        data: arr.map(item => item?.produtividadeSacasHa)
                    }
                ];
            });

            this.dadosAreaPlantadaGrafico = dadosAreaPlantadaGrafico;
            this.categoriasAreaPlantadaGrafico = categorias;
            this.dadosProdutividadeGrafico = dadosProdutividadeGrafico;
            this.categoriasProdutividadeGrafico = categorias;
        },

        async atualizarCodigosCulturas(codigoCultura) {
            this.codigosCulturas = codigoCultura;
            await this.buscarAreasPlantadasMapBiomas();
        },

        async pesquisaInteligente() {
            try {
                await InteligenciaTerritorialService.pesquisar(this.car).then(
                    ({ data }) => {
                        this.informacoesCar = data?.car[0];
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.inteligenciaTerritorial.erro.naoFoiPossivelIdentificarOCar')
                });
            }
        },

        async atualizarFiltro() {
            if (this.$route?.params?.car) {
                this.filtros = {
                    ...this.filtros,
                    tipoAgrupamento: null,
                    idsMunicipios: [this.$route?.params?.codMunicipioIbge],
                    siglaEstado: this.$route?.params?.uf,
                    codigosCars: [this.$route?.params?.car]
                };
            }
            this.validacaoBreadcrumb();
        },
        validacaoBreadcrumb() {
            if (this.$route?.params?.car) {
                this.validacaoBreadcrumbCar();
            }
        },
        validacaoBreadcrumbCar() {
            let municipioId;
            if (this.informacoesCar.length > 0) {
                municipioId = this.informacoesCar?.idMunicipio;
            } else {
                municipioId = this.$route?.params?.car.split('-')[1];
            }
            this.breadcrumb = [
                { nome: this.$t('mensagens.inteligenciaTerritorial.visaoGeral'), rota: '/inteligencia-territorial' },
                {
                    nome: this.$t('mensagens.inteligenciaTerritorial.estadoDepartamento'),
                    rota: '/inteligencia-territorial/' + this.$route?.params?.uf
                },
                {
                    nome: this.$t('mensagens.inteligenciaTerritorial.municipioLocalidade'),
                    rota:
                        '/inteligencia-territorial/' +
                        this.$route?.params?.uf +
                        '/' +
                        municipioId
                },
                { nome: this.$t('mensagens.inteligenciaTerritorial.imovel.titulo'), rota: '#' }
            ];
        },

        async buscarSituacaoTerritorio() {
            const filtro = {
                car: this.car,
                idsCategoria: CamadasCategorias.filter(cc =>
                    [
                        'EMBARGOS',
                        'DESMATAMENTOS',
                        'AREAS_PROTEGIDAS',
                        'SOCIAL'
                    ].includes(cc?.codigo)
                ).map(cc => cc?.id)
            };

            MonitoramentoSocioambientalService.buscarSituacaoPorCar(filtro)
                .then(({ data }) => {
                    data.situacoesCamadaCategoria.forEach(situacao => {
                        situacao.diagnosticos.sort((a, b) => {
                            return a?.camada?.nome.localeCompare(b?.camada?.nome);
                        });

                        Object.keys(situacao?.diagnosticos).forEach(item => {
                            if (
                                situacao.diagnosticos[item].camada.nome ===
                                'Áreas embargadas'
                            ) {
                                situacao.diagnosticos[item].camada.nome =
                                    'Áreas embargadas (IBAMA)';
                            } else if (
                                situacao.diagnosticos[item].camada.nome ===
                                'Monitoramento Desmatamento'
                            ) {
                                situacao.diagnosticos[item].camada.nome =
                                    'Desmatamento Lyra';
                            }
                        });
                    });
                    this.carSituacaoCamadaCategoria = [];
                    this.carSituacaoCamadaCategoria.push(
                        data?.situacoesCamadaCategoria[2],
                        data?.situacoesCamadaCategoria[3],
                        data?.situacoesCamadaCategoria[1],
                        data?.situacoesCamadaCategoria[0]
                    );
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.inteligenciaTerritorial.erro.ocorreuUmErroAoBuscarDadosAreaMonitorada')
                    });
                });
        },

        exibirModalVisualizarEmbargosInteligenciaTerritorial(situacao) {
            this.situacao = {
                ...situacao,
                diagnosticos: situacao?.diagnosticos.map(d => ({
                    ...d,
                    camada: { ...d?.camada, opacidade: 100 },
                    status: d?.status,
                    nivelAlerta: d?.nivelAlerta
                }))
            };

            this.showModalVisualizarEmbargosInteligenciaTerritorial = true;
        },

        async buscarGeometriaCar() {
            await TerritorioService.findGeometryByCAR(this.car)
                .then(({ data }) => {
                    this.territorioGeometria = data;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.inteligenciaTerritorial.erro.ocorreuUmErroAoBuscarDadosAreaMonitorada')
                    });
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.inteligencia-territorial-imovel {
    font-family: 'Roboto', 'sans serif' !important;

    .inteligencia-territorial-container__container {
        margin: 8px 5px 10px 5px;

        h3 {
            margin-bottom: 6px;
            margin-top: 15px;
            color: #3b3b3b;
            font-size: 16px;
            font-weight: 600;
        }

        .dados-gerais-territorio-monitoramento__lista {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;

            .dados-gerais-territorio-monitoramento__lista-item {
                width: 24.25%;
                margin: 2px 10px 2px 0px;

                &:last-child {
                    margin: 2px 0px;
                }
            }
        }
    }

    .secao-container--conteudo {
        margin-top: 20px;
    }

    .grid-layout-potencial-agro {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
    }

    .row-span {
        grid-row: span 3;
    }
}
</style>
